import React from "react";
import { useTranslation } from "react-i18next";
import type { MemberSettings } from "../../../../hooks/agenda";
import { browserTimeZone } from "./agendaDates";
import { hoursSummary } from "./hoursSummary";

/** A person's availability in a few lines: none means bookable at any time, seven closed days never. */
const AvailabilityText: React.FC<{ settings: MemberSettings | null }> = ({
  settings,
}) => {
  const { t, i18n } = useTranslation();
  if (!settings) return <>{t("agenda.availability.anyTime")}</>;
  const lines = hoursSummary(t, settings.hours, i18n.language);
  if (lines.length === 0) return <>{t("agenda.availability.never")}</>;
  return (
    <>
      {lines.map((line) => (
        <span key={line} className="block">
          {line}
        </span>
      ))}
      {settings.tz && settings.tz !== browserTimeZone() && (
        <span className="block text-gray-500">
          {t("agenda.availability.inTimezone", { timezone: settings.tz })}
        </span>
      )}
    </>
  );
};

export default AvailabilityText;
